import React from 'react';
import { isEdge } from 'react-device-detect';
import styles from './WrappingContainer.module.scss';
const WrappingContainer = ({ children }) => {
  return (
    <div
      className={`${styles['wrapping-container']} ${
        isEdge ? styles['edge'] : ''
      }`}
    >
      {children}
    </div>
  );
};

export default WrappingContainer;
